/**
 * WorkNest APIs wrap payloads in `{ success, data, errors, statusCode }`.
 * Login/refresh return token DTOs inside `data` (or unwrapped in some environments).
 */
export function extractTokenPairFromApiBody(body: unknown): { accessToken: string; refreshToken: string } | null {
  if (!body || typeof body !== 'object') {
    return null;
  }
  const root = body as { data?: unknown; accessToken?: string; refreshToken?: string };
  const inner = root.data !== undefined ? root.data : body;
  if (!inner || typeof inner !== 'object') {
    return null;
  }
  const access = (inner as { accessToken?: string; AccessToken?: string }).accessToken ?? (inner as { AccessToken?: string }).AccessToken;
  const refresh = (inner as { refreshToken?: string; RefreshToken?: string }).refreshToken ?? (inner as { RefreshToken?: string }).RefreshToken;
  if (typeof access !== 'string' || typeof refresh !== 'string' || !access || !refresh) {
    return null;
  }
  return { accessToken: access, refreshToken: refresh };
}
